import Vue from "vue";
import Router from "vue-router";
import login from "@/views/login/login";
import index from "@/views/index/index";
import chat from "@/views/chat/chat.vue";
import customer from "@/views/setting/customer";
import operator from "@/views/setting/operator";
import personal from "@/views/setting/personal";
import customerPhone from "@/views/setting/customer-phone";
import customerProduct from "@/views/setting/customer-product";
import customerProductLastest from "@/views/setting/customer-product-lastest";
import messageSending from "@/views/setting/message-sending.vue";
import messageHistory from "@/views/setting/message-history.vue";
import serviceMaintenance from "@/views/setting/service-maintenance.vue";
import serviceProviderMaintenance from "@/views/setting/service-provider-maintenance.vue";
import aiEmail from "@/views/setting/ai-email.vue";
import openClawManagement from "@/views/setting/open-claw-management.vue";
import { getToken } from "@/utils/cookies";

Vue.use(Router);

/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
	return routerPush.call(this, location).catch((error) => error);
};

const router = new Router({
	routes: [
		{
			path: "/",
			redirect: "/chat",
			hidden: true,
		},
		{
			path: "/login",
			name: "login",
			component: login,
			hidden: true,
		},
		{
			path: "/",
			component: index,
			name: "customerCommunication",
			iconCls: "el-icon-service",
			leaf: true, // 只有一个节点
			children: [
				{
					path: "/chat",
					component: chat,
					name: "customerCommunication",
				},
			],
		},
		{
			path: "/",
			component: index,
			name: "setup",
			iconCls: "el-icon-setting",
			children: [
				{
					path: "/setting/customer",
					name: "myClient",
					component: customer,
				},
				{
					path: "/setting/customer-phone/:id",
					component: customerPhone,
					name: "customerBinding",
					hidden: true,
				},
				{
					path: "/setting/customer-product/:id",
					component: customerProduct,
					name: "productSettings",
					hidden: true,
				},
				{
					path: "/setting/customer-product-lastest/:id",
					component: customerProductLastest,
					name: "syncSettings",
					hidden: true,
				},
				{
					path: "/setting/personal",
					name: "personalInformation",
					component: personal,
				},
				{
					path: "/setting/operator",
					name: "authorizationSettings",
					component: operator,
					hidden: true,
				},
				{
					path: "/setting/message-sending",
					name: "messageSending",
					component: messageSending,
				},
				{
					path: "/setting/message-sending/:id",
					name: "messageSending",
					component: messageHistory,
					hidden: true,
				},
				{
					path: "/setting/ai-email",
					name: "aiEmail",
					component: aiEmail,
				},
				{
					path: "/setting/open-claw-management",
					name: "openClawManagement",
					component: openClawManagement,
				},
				{
					path: "/setting/service-maintenance",
					name: "omelinkUserServiceMaintenance",
					component: serviceMaintenance,
				},
				{
					path: "/setting/service-maintenance/:id",
					name: "omelinkUserServiceMaintenance",
					component: serviceProviderMaintenance,
					hidden: true,
				},
			],
		},
	],
});

// 路由守卫
router.beforeEach((to, from, next) => {
	if (to.path == "/login") {
		next();
	} else {
		if (getToken()) {
			next();
		} else {
			next({
				path: "login",
				query: {
					redirect: to.fullPath,
				}, // 将跳转的路由path作为参数，登录成功后跳转到该路由
			});
		}
	}
});

export default router;
